import { Type } from '@sinclair/typebox';

// Company info schema for DaData API responses
export const CompanyInfoSchema = Type.Object({
  name: Type.String(),
  full_name: Type.Optional(Type.String()),
  inn: Type.String(),
  ogrn: Type.Optional(Type.String()),
  type: Type.String(), // 'legal' | 'individual'
  status: Type.String(),
  address: Type.Optional(Type.String()),
  city: Type.Optional(Type.String()),
  phones: Type.Array(Type.String()),
  emails: Type.Array(Type.String()),
  director: Type.Optional(Type.String()),
  director_post: Type.Optional(Type.String()),
});

export type CompanyInfo = typeof CompanyInfoSchema.T;

/**
 * DTO для заполнения формы юридического лица из внешнего источника (DaData / ЕГРЮЛ).
 * Используется при автозаполнении форм создания/редактирования контрагентов.
 */
export interface CompanyFormDto {
  entity_type: 'company' | 'sole_proprietor';
  short_name: string;
  full_name: string | null;
  inn: string;
  ogrn: string | null;
  legal_address: string | null;
}

/**
 * Преобразует CompanyInfo (ответ DaData) в DTO для заполнения формы.
 * ИП (individual) → sole_proprietor, юрлицо (legal) → company.
 */
export function companyInfoToFormDto(company: CompanyInfo): CompanyFormDto {
  return {
    entity_type: company.type === 'legal' ? 'company' : 'sole_proprietor',
    short_name: company.name,
    full_name: company.full_name ?? null,
    inn: company.inn,
    ogrn: company.ogrn ?? null,
    legal_address: company.address ?? null,
  };
}
